import { lazy } from 'react'

import Consuntivi from './consuntivi'

import createAvanzamentiFilter from './filter'

export const createAvanzamenti = ({ filterPath }) => ({
    path: filterPath,
    title: 'Avanzamento casi',
    authenticated: true,
    component: createAvanzamentiFilter({ filterPath }),
    pages: [
        {
            path: '/:avanzamentoId',
            title: 'Avanzamento caso: {{params.avanzamentoId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Consuntivi]
        }
    ]
})

export default createAvanzamenti({ filterPath: '/avanzamento-casi' })